export default "July 2, 2019";